import { createApi } from '@reduxjs/toolkit/query/react'
import { IChatboxResponse, ITopics } from '../../interfaces/chats/IChatResponse'
import { deviceAxiosQuery } from '../../utils/axios/device.axios'

export const chatboxApi = createApi({
    reducerPath: 'chatbox',
    baseQuery: deviceAxiosQuery(),
	tagTypes: ['topics', 'chats'],
    endpoints: (builder) => ({
		chatbox: builder.mutation<{data: IChatboxResponse}, {message: string, topic?: string, user: {name: string, email: string, id: string}}>({
			query: (payload) => ({
				url: `/chatbox/chat`,
				method: 'POST',
				data: payload
			})
		}),
		topicsList: builder.query<{data: ITopics[]}, {type: 'HISTORY' | 'TOPIC' | null, userId: string}>({
			query: ({type, userId}) => ({
				url: type ? `/chatbox/topics?type=${type}&userId=${userId}` : `/chatbox/topics?userId=${userId}`,
				method: 'GET'
			}),
			providesTags: ['topics']
		}),
		getTopicChats: builder.mutation<{data: IChatboxResponse[]}, {topic: string, userId: string}>({
			query: ({topic, userId}) => ({
				url: `/chatbox/chat?topic=${topic}&userId=${userId}`,
				method: 'GET'
			})
		}),
		saveTopic: builder.mutation<{data: IChatboxResponse[]}, string>({
			query: (topic) => ({
				url: `/chatbox/chat/${topic}/topic`,
				method: 'PUT'
			}),
			invalidatesTags: ['topics']
		}),
		reactMessage: builder.mutation<{data: IChatboxResponse[]}, {action: 'like' | 'dislike' | 'favorite', messageId: string}>({
			query: ({action, messageId}) => ({
				url: `/chatbox/messages/${messageId}/reaction`,
				method: 'PUT',
				data: {action}
			}),
		}),
    }),
})

export const {
	useChatboxMutation,
	useTopicsListQuery,
	useGetTopicChatsMutation,
	useSaveTopicMutation,
	useReactMessageMutation
} = chatboxApi